export default {
  aboutUs: {
    id: 'header_to_about_us',
    defaultMessage: 'About us',
  },
  sellYourTech: {
    id: 'header_to_buyback',
    defaultMessage: 'Sell your tech',
  },
  verifiedRefurbished: {
    id: 'header_to_verified_refurbished',
    defaultMessage: 'Verified Refurbished',
  },
  backStories: {
    id: 'header_to_back_stories',
    defaultMessage: 'Back Stories',
  },
  repairAndCare: {
    id: 'header_to_repair_and_care',
    defaultMessage: 'Repair & Care',
  },
  endFastTech: {
    id: 'header_to_end_fast_tech',
    defaultMessage: 'End fast tech',
  },
  techJournal: {
    id: 'header_to_tech_journal',
    defaultMessage: 'Tech journal',
  },
  onDemandRepair: {
    id: 'header_to_on_demand_repair',
    defaultMessage: 'On-demand repair',
  },
  bmProButton: {
    id: 'header_to_bm_pro_website_mobile',
    defaultMessage: 'Back Market for business',
  },
  help: {
    id: 'header_to_help',
    defaultMessage: 'Help',
  },
}
